export type PetSource = 'patient-info-window' | 'register-dentistry';
export type PetAlertKind = 'drug-allergy' | 'past-history' | 'family-history' | 'surgery-history' | 'special-identity';

// Wire contract: no patient ID, name, dates, or clinical free text.
export interface PetContextSnapshot {
  Version: 1;
  ContextKey: string;
  Revision: number;
  Source: PetSource;
  HasPatient: boolean;
  AlertKinds: PetAlertKind[];
  BirthdayNearby: boolean;
}

export interface PetPairing { Ticket: string; ExpiresAt: string; }

/** Matches the patient-info-window tag categories, not the raw clinical text. */
export function petAlertKinds(allergy: string, remark: string, identity: string): PetAlertKind[] {
  const kinds: PetAlertKind[] = [];
  if ((allergy || '').split(/[;,]/).some(part => !!part.trim())) kinds.push('drug-allergy');
  const names: { [key: string]: PetAlertKind } = {
    '既往病史': 'past-history', '家族病史': 'family-history', '手術病史': 'surgery-history'
  };
  (remark || '').split(/\r?\n/).forEach(line => {
    const match = line.match(/^\s*\[(既往病史|家族病史|手術病史)\]\s*[：:]\s*(.*)$/);
    if (match && match[2].trim() && !kinds.includes(names[match[1]])) kinds.push(names[match[1]]);
  });
  const value = (identity || '').trim();
  if (value && (!/^[01]+$/.test(value) || value.includes('1'))) kinds.push('special-identity');
  return kinds.sort();
}

/** Calendar dates only: UTC day arithmetic avoids DST, and checks adjacent years. */
export function petBirthdayNearby(birthday: Date, references: Date[]): boolean {
  if (!(birthday instanceof Date) || !Number.isFinite(birthday.getTime()) || birthday.getFullYear() < 1901) return false;
  return references.some(reference => {
    if (!(reference instanceof Date) || !Number.isFinite(reference.getTime()) || reference.getFullYear() < 1901) return false;
    const year = reference.getFullYear();
    const day = Date.UTC(year, reference.getMonth(), reference.getDate());
    return [year - 1, year, year + 1].some(candidateYear => {
      const month = birthday.getMonth();
      // Feb 29 is observed on Feb 28 in non-leap years.
      const date = Math.min(birthday.getDate(), new Date(candidateYear, month + 1, 0).getDate());
      return Math.abs(Date.UTC(candidateYear, month, date) - day) <= 3 * 86400000;
    });
  });
}
